import React, { Component } from 'react'
import { connect } from 'react-redux'
import trans, { isTrans } from "trans"

import {
    css,
    Field,
    TextInput,
    Theme,
    Div,
    Grid,
    GridCell,
    Icon,
    FieldLabel,
} from "@bdfx/mergado-ui-kit"

import { URL } from "app/config/api-config";
import { iconDisabledColor } from "../components/tools-panel";
import { ICONS_VERSION } from 'shape-edit/forms/helpers';
import { ReduxList } from 'app/types/app-types';
import { SizeItem } from 'settings/components/sizes-settings';
import { find } from 'lodash';

interface Props {
    customOnly: boolean
    placeholder: string
    sizes: ReduxList<SizeItem>
    showInput: boolean
    selectedSizeId: string
    handleSelectId: Function
    filter: string
}

interface State {
    filter: string
    expandSelect: boolean
}

class SizeSelect extends Component<Props, State> {
    constructor(props) {
        super(props)

        const options = props.items || []

        this.state = {
            filter: props.filter ? props.filter : '',
            expandSelect: !!props.filter,
        };
    }

    handleFilter = (value) => {
        this.setState({ filter: value })
    }


    render() {
        const { placeholder, selectedSizeId, sizes, customOnly } = this.props
        const { filter, expandSelect } = this.state

        const filteredOptions: SizeItem[] = sizes.isLoaded ? sizes.data.filter((option) => {
            const regex = new RegExp(this.state.filter, "i")
            const regExFilter = regex.test(option.name || (isTrans(option.trans_string) ? trans(option.trans_string) : option.trans_string))

            const isCustomFormat = !option.trans_string && option.format !== 'separator' && option.id !== null
            const customFilter = (customOnly && isCustomFormat) || (!customOnly && !isCustomFormat && !(option.format === 'separator' && option.name === 'custom_formats'))

            return customFilter && regExFilter
        }) : null

        const selectedSize = sizes.data && Array.isArray(sizes.data) ? find(sizes.data, (size: SizeItem) => {
            return size?.id === selectedSizeId
        }) : null


        if (customOnly && filteredOptions.length === 0) {
            return <React.Fragment />
        }

        return (
            <React.Fragment>
                {customOnly &&
                    <FieldLabel>{trans('custom_formats')}</FieldLabel>
                }

                <StyledField className={`muk-inputgroupv__queries`}>
                    <StyledOptionDiv className={'selected-size'} onClick={() => this.setState({ expandSelect: !expandSelect })}>
                        <Grid cols={'auto 12px'}>
                            <GridCell className={'hide-overflow'}>
                                {!selectedSize && selectedSizeId !== 'new' &&
                                    <span style={{ color: '#3a3a3a' }}>
                                        {trans('select_format')}
                                    </span>
                                }

                                {selectedSize &&
                                    <React.Fragment>
                                        {selectedSize.format !== 'custom' &&
                                            <img src={`${URL.laravelBase}img/icons/engines/${selectedSize.format}.svg?v=${ICONS_VERSION}`} />
                                        }

                                        <span className={'text'}>
                                            {selectedSize.name || (isTrans(selectedSize.trans_string) ? trans(selectedSize.trans_string) : selectedSize.trans_string)} ({selectedSize.width} × {selectedSize.height} px)
                                        </span>
                                    </React.Fragment>
                                }
                            </GridCell>
                            <GridCell>
                                <Icon type={expandSelect ? 'chevron-up' : 'chevron-down'} color={iconDisabledColor} size={12} />
                            </GridCell>
                        </Grid>
                    </StyledOptionDiv>

                    {expandSelect &&
                        <Div marginTop="20px">
                            <TextInput
                                className={'muk-inputgroupv__filter_input'}
                                type={"search"}
                                onClear={() => this.setState({ filter: "" })}
                                style={{ marginBottom: "5px" }}
                                onChange={this.handleFilter}
                                value={filter}
                                placeholder={placeholder}
                            />

                            <StyledDiv>
                                {filteredOptions.map((option, key) => {
                                    if (option.id === null && option.format === 'separator') {
                                        return <StyledSeparatorDiv key={option.name + key}>
                                            {isTrans(option.name) ? trans(option.name) : option.name}
                                        </StyledSeparatorDiv>
                                    }
                                    return <StyledOptionDiv
                                        key={option.id}
                                        onClick={() => {
                                            this.props.handleSelectId(option.id)
                                            this.setState({ expandSelect: false })
                                        }}
                                        className={option.id === selectedSizeId ? 'selected' : ''}
                                    >
                                        {option.format !== 'custom' &&
                                            <img src={`${URL.laravelBase}img/icons/engines/${option.format}.svg?v=${ICONS_VERSION}`} />
                                        }

                                        <span className={'text'}>
                                            {option.name || (isTrans(option.trans_string) ? trans(option.trans_string) : option.trans_string)} ({option.width} × {option.height} px)
                                        </span>
                                    </StyledOptionDiv>
                                })
                                }

                                {/* <StyledSeparatorDiv>{trans('new')}</StyledSeparatorDiv>
                                <StyledOptionDiv className={selectedSizeId === 'new' ? 'selected' : ''} onClick={() => {
                                    this.props.handleSelectId('new')
                                    this.setState({ expandSelect: false })
                                }
                                }>
                                    <span className={'text'}>--- {trans('add_new')} ---</span>
                                </StyledOptionDiv> */}
                            </StyledDiv>
                        </Div>
                    }
                </StyledField>
            </React.Fragment>
        )
    }
}

const StyledField = css(Field)({
    ' .selected': {
        background: Theme.blue,
        color: '#fff',
    },
    ' .selected-size': {
        border: '1px solid #eee',
        borderRadius: Theme.radius,
    }
})

const StyledOptionDiv = css('div')({
    cursor: 'pointer',
    padding: '8px 15px',
    margin: 0,
    borderBottom: '1px solid #eee',
    whiteSpace: 'nowrap',
    ' img': {
        marginRight: '10px',
        maxHeight: '20px',
        maxWidth: '20px',
        verticalAlign: 'middle'
    },
    ' .text': {
        lineHeight: '16px',
        verticalAlign: 'middle'
    },
    ' .hide-overflow': {
        overflow: 'hidden',
    }
})

const StyledSeparatorDiv = css('div')({
    padding: '8px 15px',
    margin: 0,
    borderBottom: '1px solid #ccc7c2',
    borderTop: '1px solid #ccc7c2',
    fontWeight: 'bold',
    background: '#ece9e7',
})

const StyledDiv = css('div')({
    marginTop: '10px',
    padding: 0,
    border: '1px solid #eee',
    borderRadius: Theme.radius,
    maxHeight: '360px',
    overflowY: 'auto',
})

function mapStateToProps(state) {
    return {
        sizes: state.sizes,
    }
}

export default connect(mapStateToProps, {
})(SizeSelect)